import { useRef } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import useClickOutside from "../../../../hooks/useClickOutside";

const WorkoutConfiguration = ({
  weeks,
  cycleId,
  programNumber,
  handleDiscard,
}) => {
  const footerRef = useRef(null);
  useClickOutside(footerRef, handleDiscard, true);
  return (
    <footer className="workout-configuration" ref={footerRef}>
      <button
        data-button-type="tertiary"
        data-icon-only="true"
        onClick={handleDiscard}
      >
        <SvgIcon src="/img/new-icons/red-cross.svg" noFilterOnLight />
      </button>

      {weeks["1"].map((workout, workoutIndex) => (
        <div key={`workout${workoutIndex}`} className="workout">
          <p className="s2">Workout {parseInt(workoutIndex) + 1}</p>
          <a
            data-button-type="secondary"
            role="button"
            data-icon-only
            aria-disabled={weeks["1"].length === 1}
            href={`/actions/cycle/coach-remove-session/${cycleId}/${programNumber}/${
              parseInt(workoutIndex) + 1
            }/${Object.keys(weeks).length}`}
          >
            <SvgIcon src="/img/new-icons/red-trash.svg" noFilterOnLight />
          </a>
        </div>
      ))}

      <div className="flex justify-center mt-6">
        <a
          data-button-type="text"
          role="button"
          aria-disabled={weeks["1"].length === 7}
          href={`/actions/cycle/coach-add-session/${cycleId}/${programNumber}/${
            Object.keys(weeks).length
          }`}
        >
          <SvgIcon src="/img/new-icons/add-gradient-icon.svg" noFilterOnLight />
          <span>Add Workout</span>
        </a>
      </div>
    </footer>
  );
};

export default WorkoutConfiguration;
